import { render, staticRenderFns } from "./MiniDepStatTableDepTiers.component.vue?vue&type=template&id=3d67e54a&scoped=true&"
import script from "./MiniDepStatTableDepTiers.component.vue?vue&type=script&lang=js&"
export * from "./MiniDepStatTableDepTiers.component.vue?vue&type=script&lang=js&"
import style0 from "./MiniDepStatTableDepTiers.component.vue?vue&type=style&index=0&id=3d67e54a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d67e54a",
  null
  
)

export default component.exports